module.exports = __webpack_public_path__ + "img/img-header-mobile.db5379a.webp";